const STATE = {
  INITIALIZED: 'initialized',
  CONNECTING: 'connecting',
  CONNECTED: 'connected',
  UNAVAILABLE: 'unavailable',
  FAILED: 'failed',
  DISCONNECTED: 'disconnected',
}

export default {
  STATE,
  NOT_CONNECTED_STATES: [STATE.UNAVAILABLE, STATE.DISCONNECTED],
}
